import { sceneCoordsToViewportCoords } from "@excalidraw/common";
import { getElementAbsoluteCoords } from "@excalidraw/element";

import type {
  ElementsMap,
  NonDeletedExcalidrawElement,
} from "@excalidraw/element/types";

import { useExcalidrawAppState } from "../components/App";

import "./ElementCanvasButtons.scss";

import type { AppState } from "../types";

const CONTAINER_PADDING = 5;

type ElementCanvasButtonsPosition = "top-right" | "top-center";

const getContainerCoords = (
  element: NonDeletedExcalidrawElement,
  appState: AppState,
  elementsMap: ElementsMap,
  position: ElementCanvasButtonsPosition,
) => {
  const [x1, y1, x2] = getElementAbsoluteCoords(element, elementsMap);

  const scenePoint =
    position === "top-center"
      ? { sceneX: (x1 + x2) / 2, sceneY: y1 }
      : { sceneX: x2, sceneY: y1 };

  const { x: viewportX, y: viewportY } = sceneCoordsToViewportCoords(
    scenePoint,
    appState,
  );

  if (position === "top-center") {
    return {
      x: viewportX - appState.offsetLeft,
      y: viewportY - appState.offsetTop,
      transform: "translate(-50%, -110%)",
    };
  }

  return {
    x: viewportX - appState.offsetLeft + 10,
    y: viewportY - appState.offsetTop,
    transform: undefined,
  };
};

export const ElementCanvasButtons = ({
  children,
  element,
  elementsMap,
  className,
  position = "top-right",
}: {
  children: React.ReactNode;
  element: NonDeletedExcalidrawElement;
  elementsMap: ElementsMap;
  className?: string;
  position?: ElementCanvasButtonsPosition;
}) => {
  const appState = useExcalidrawAppState();

  if (
    appState.contextMenu ||
    appState.newElement ||
    appState.resizingElement ||
    appState.isRotating ||
    appState.openMenu ||
    appState.viewModeEnabled
  ) {
    return null;
  }

  const { x, y, transform } = getContainerCoords(
    element,
    appState,
    elementsMap,
    position,
  );

  return (
    <div
      className={
        className
          ? `excalidraw-canvas-buttons ${className}`
          : "excalidraw-canvas-buttons"
      }
      style={{
        top: `${y}px`,
        left: `${x}px`,
        // width: CONTAINER_WIDTH,
        padding: CONTAINER_PADDING,
        transform,
      }}
    >
      {children}
    </div>
  );
};
